import React, { useState, useEffect } from "react";
import styles from "./PageHandler.module.css";
import { debounce } from "../../../../../../../common/utils";
import { CustomIconButton, CustomTextField, icon } from "../../../../../../../common/components";

const debouncedSearch = debounce((func) => func(), 500);

export default function PageHandler({ documentId, numberOfPages = 0, page = 0, onChangePage }) {
	const [localPage, setLocalPage] = useState(0);
	const [automaticPageChangeEnabled, setAutomaticPageChangeEnabled] = useState(true);

	useEffect(() => {
		if (automaticPageChangeEnabled) {
			setLocalPage(page + 1);
		}
	}, [page, automaticPageChangeEnabled]);

	const handleChangePage = (value) => {
		let tempPage = value ? Number.parseInt(value, 10) : value;
		if (tempPage !== "" && (Number.isNaN(tempPage) || tempPage <= 0)) {
			tempPage = 1;
		}
		if (numberOfPages < tempPage) {
			tempPage = numberOfPages;
		}
		setLocalPage(tempPage);
		debouncedSearch(() => {
			onChangePage(tempPage - 1);
		});
	};
	const handleDisableAutoInput = () => {
		setAutomaticPageChangeEnabled(false);
		if (!localPage) {
			setLocalPage(1);
		}
	};
	const handleEnableAutoInput = () => {
		setAutomaticPageChangeEnabled(true);
	};

	return (
		<>
			{documentId && (
				<div className={styles.pageContainer}>
					<div className={styles.pageContainer__inputContainer}>
						<CustomIconButton
							className={`${styles.pageContainer__button} ${styles["pageContainer__button--left"]}`}
							disabled={localPage <= 1}
							icon={icon.faChevronLeft}
							size="xs"
							onClick={() => handleChangePage(localPage - 1)}
						/>
						<CustomTextField
							classes={{ root: styles.pageContainer__pageInput }}
							data-testid="page.handler.textfield"
							inputProps={{
								className: styles["pageContainer__pageInput--padding"],
							}}
							type="text"
							value={localPage}
							variant="outlined"
							onBlur={handleEnableAutoInput}
							onChange={(e) => handleChangePage(e.target.value)}
							onClick={handleDisableAutoInput}
						/>
					</div>
					<CustomIconButton
						className={`${styles.pageContainer__button} ${styles["pageContainer__button--right"]}`}
						disabled={localPage >= numberOfPages}
						icon={icon.faChevronRight}
						size="xs"
						onClick={() => handleChangePage(localPage + 1)}
					/>
					<div className={styles.pageContainer__pageLimit}>/{numberOfPages}</div>
				</div>
			)}
		</>
	);
}
